module.exports = __webpack_public_path__ + "img/donante-fantasy-land.f0613e9c.png";